export default {
  key: 'folderDuplication',
  type: 'boolean',
  label: 'Folder duplication',
  description: 'Adds Duplicate to the folder menu in My Files, so you can copy a folder with everything inside it.',
  default: false,
  group: 'My Files',
}
